import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Heading, Stack } from '@chaser/components';
import PageContainer from '../../../components/PageContainer/index';
import { setShortCode } from '../../../duck/actions/organisation';
import { useQueryStringState } from '../../../hooks/useGlobalState';
import OrganisationService from '../../../services/organisation-service';
import usePush from '../../../hooks/usePush';
import RouterButton from '../../../components/RouterButton';
import userOrganisations from '../../../hooks/useUserOrganisations';

const AlreadyConnected = () => {
  const organisations = userOrganisations();
  const [{ organisation: shortCode }] = useQueryStringState();
  const dispatch = useDispatch();
  const { firstName } = useSelector(state => state.loginReducer);

  const { execute: sync } = usePush(async () => {
    await OrganisationService.sync(shortCode);
  });

  const { Name, name } =
    organisations.find(({ ShortCode }) => {
      return ShortCode === shortCode;
    }) || {};

  useEffect(() => {
    dispatch(setShortCode(shortCode));
    sync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageContainer>
      <Card p="large">
        <Stack gap="medium" alignItems="flex-start">
          <Heading data-trackingid="welcome-org-msg" data-testid="welcome-org-msg">
            Welcome {firstName}
          </Heading>
          <Heading
            data-trackingid="welcome-org-submsg"
            data-testid="welcome-org-submsg"
            fontSize="heading.3"
            fontWeight="bold"
            as="h3"
          >
            {`You've connected ${name || Name}`}
          </Heading>
          <RouterButton to="/">Go to organisation</RouterButton>
        </Stack>
      </Card>
      <div />
    </PageContainer>
  );
};

export default AlreadyConnected;
